
            const data = {"name":"glyph/24/filter","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M22 0H2a1 1 0 0 0-1 1v3a1 1 0 0 0 .293.707L9 12.414V23a1 1 0 0 0 1.6.8l4-3a1 1 0 0 0 .4-.8v-7.586l7.707-7.707A1 1 0 0 0 23 4V1a1 1 0 0 0-1-1Z\" class=\"nc-icon-wrapper\" _fill=\"#272c33\"/>","originalColors":[{"type":"fill","color":"#272c33"}],"stopColors":[]}}
        
                    module.exports = data
                    